// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-class{border:2px solid #4dbee7;border-radius:5px;padding:5px}.wrapper-class.cell{width:calc(100% - 14px);background:#fff;position:absolute;left:0px}.unselected-cell:hover{background-color:#def}", ""]);
// Exports
module.exports = exports;
